/**
 * User-facing message from order/cart API errors (e.g. insufficient stock).
 */
export function getOrderErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
    const data = error?.response?.data;
    if (!data) {
        return error?.message || fallback;
    }

    const productTitle =
        data.productTitle ||
        data.product_title ||
        data.productName;

    const available = data.availableQty ?? data.available;
    const requested = data.requestedQty ?? data.requested;

    if (
        productTitle &&
        (available !== undefined && available !== null) &&
        requested !== undefined
    ) {
        const size = data.selectedSize ? ` (size ${data.selectedSize})` : '';
        return `Insufficient stock for "${productTitle}"${size}. Available: ${available}, requested: ${requested}.`;
    }

    return data.message || data.msg || data.err || fallback;
}

/** Show order/cart API errors with error styling (not success checkmark). */
export function showOrderErrorToast(showToast, error, fallback) {
    showToast({
        message: getOrderErrorMessage(error, fallback),
        variant: 'error',
    });
}
